export enum LocalStorageNames {
  userContext = "userContext",
}
